<template>
  <div>
    <el-dialog
            :title="title"
            :visible="visible"
            width="950px"
            :close-on-click-modal="false"
            @close="onClose"
            class="bind-oilshop-dialog"
    >
      <!-- 查询区域 -->
      <div class="query-section">
        <div class="section-header">
          <div class="header-left">
            <i class="el-icon-search section-icon"></i>
            <span class="section-title">查询条件</span>
          </div>
        </div>
        <div class="query-form">
          <el-form :inline="true" size="medium" label-width="100px">
            <el-form-item label="机构名称">
              <el-input
                      v-model="keywords"
                      placeholder="请输入机构名称"
                      clearable
                      prefix-icon="el-icon-office-building"
                      style="width: 280px"
                      @keyup.enter="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                      type="primary"
                      icon="el-icon-search"
                      @click="handleQuery"
                      class="query-btn"
              >
                查询
              </el-button>
              <el-button
                      icon="el-icon-refresh"
                      @click="handleReset"
                      class="reset-btn"
              >
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!-- 保存区域 -->
      <div class="save-section">
        <div class="section-header">
          <div class="header-left">
            <i class="el-icon-link section-icon"></i>
            <span class="section-title">油站绑定</span>
          </div>
          <div class="selected-info" v-if="curShop">
            <el-tag type="success" size="medium">
              <i class="el-icon-check"></i>
              已选择: {{ curShop.name }}
            </el-tag>
          </div>
        </div>
        <div class="save-form">
          <el-form :inline="true" size="medium" label-width="100px">
            <div>
              <el-form-item label="油站选择" required>
                <el-input
                        v-model="searchForm.shop_name"
                        placeholder="请选择油站"
                        readonly
                        @click.native="chooseShop"

                        class="shop-select-input"
                >
                  <template #append>
                    <el-button
                            icon="el-icon-search"
                            @click="chooseShop"
                            class="select-btn"
                    />
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item label="补贴比例" required>
                <el-input
                        v-model="searchForm.subsidy_rate"
                        placeholder="请选择补贴比例"
                        class="shop-select-input"
                >
                  <template #append>
                    %
                  </template>
                </el-input>
              </el-form-item>
            </div>
          <div style="margin-top: 10px">
            <el-form-item label="太米门店ID" required>
              <el-input
                      v-model="searchForm.foreign_shop_id"
                      placeholder="请选择太米门店ID"
                      class="shop-select-input"
              ><template #append>

              </template>
              </el-input>
            </el-form-item>
            <el-form-item label="商务比例" required>
              <el-input
                      v-model="searchForm.business_rate"
                      placeholder="请选择商务比例"
                      class="shop-select-input"
              >
                <template #append>
                  %
                </template>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                      type="success"
                      icon="el-icon-check"
                      @click="handleBind"
                      :disabled="!searchForm.shop_id"
                      class="bind-btn"
              >
                绑定保存
              </el-button>
            </el-form-item>
          </div>

          </el-form>
        </div>
      </div>

      <!-- 表格区域 -->
      <div class="table-section">
        <div class="section-header">
          <div class="header-left">
            <i class="el-icon-s-data section-icon"></i>
            <span class="section-title">油站列表</span>
          </div>
          <div class="table-info">
            <span class="total-info">
              <i class="el-icon-document"></i>
              共 {{ total }} 条记录
            </span>
          </div>
        </div>

        <div class="table-wrapper">
          <el-table
                  ref="multipleTable"
                  :data="mList"

                  stripe
                  border
                  size="medium"
                  :row-class-name="tableRowClassName"
                  @row-click="handleRowClick"
                  :highlight-current-row="true"
                  style="width: 100%; background-color: #f5f5f5;"
                  :header-cell-style="{
              background: '#f5f5f5',
              color: '#333',
              fontWeight: 'bold',
              fontSize: '14px',
              borderBottom: '2px solid #409EFF',
              height: '50px'
            }"
                  :cell-style="{
              borderRight: '1px solid #e0e0e0',
              borderBottom: '1px solid #e0e0e0',
              backgroundColor: '#f5f5f5'
            }"
                  :row-style="{ backgroundColor: '#f5f5f5' }"
          >
<!--            <el-table-column-->
<!--                    label="选择"-->
<!--                    width="70"-->
<!--                    align="center"-->
<!--                    fixed="left"-->
<!--            >-->
<!--              <template slot-scope="scope">-->
<!--                <el-radio-->
<!--                        v-model="curShop"-->
<!--                        :label="scope.row"-->
<!--                        @change="handleSelectionChange(scope.row)"-->
<!--                        class="selection-radio"-->
<!--                >-->
<!--                  {{ "" }}-->
<!--                </el-radio>-->
<!--              </template>-->
<!--            </el-table-column>-->

            <el-table-column
                    label="名称"
                    width="190"
                    sortable
            >
              <template slot-scope="scope">
                <div class="cell-content">
                  <i class="el-icon-office-building cell-icon"></i>
                  <span class="name-text">{{ scope.row.shop.name || '-' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                    label="补贴比例"
                    sortable
            >
              <template slot-scope="scope">
                <div class="cell-content">

                  <span class="name-text">{{ scope.row.subsidy_rate|| '' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                    label="商务比例"
                    sortable
            >
              <template slot-scope="scope">
                <div class="cell-content">

                  <span class="name-text">{{ scope.row.business_rate|| '' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                    label="太米门店ID"
                    sortable
            >
              <template slot-scope="scope">
                <div class="cell-content">

                  <span class="name-text">{{ scope.row.foreign_shop_id|| '' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                    label="地址"
                    min-width="200"

            >
              <template slot-scope="scope">
                <div class="cell-content">
                  <i class="el-icon-location-information cell-icon"></i>
                  <span class="address-text">{{ scope.row.shop.address || '暂无地址' }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
                    label="联系人手机"
                    width="150"
                    align="center"
            >
              <template slot-scope="scope">
                <div class="cell-content">
                  <i class="el-icon-phone cell-icon"></i>
                  <span class="mobile-text">{{ scope.row.shop.telephone || '-' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                    label="绑定时间"
                    width="190"

                    sortable
            >
              <template slot-scope="scope">
                <div class="cell-content">
                  <span>{{ dateFormat(scope.row.add_time)}}</span>
                </div>
              </template>
            </el-table-column>
<!--            <el-table-column-->
<!--                    label="状态"-->
<!--                    width="100"-->
<!--                    align="center"-->
<!--            >-->
<!--              <template slot-scope="scope">-->
<!--                <div class="cell-content">-->
<!--                  <el-tag-->
<!--                          size="small"-->
<!--                          :type="scope.row.status === 1 ? 'success' : 'info'"-->
<!--                          effect="light"-->
<!--                  >-->
<!--                    {{ scope.row.status === 1 ? '启用' : '停用' }}-->
<!--                  </el-tag>-->
<!--                </div>-->
<!--              </template>-->
<!--            </el-table-column>-->

<!--            <el-table-column-->
<!--                    label="操作"-->
<!--                    width="120"-->
<!--                    align="center"-->
<!--                    fixed="right"-->
<!--            >-->
<!--              <template slot-scope="scope">-->
<!--                <div class="action-buttons">-->
<!--                  <el-button-->
<!--                          type="text"-->
<!--                          size="small"-->
<!--                          icon="el-icon-view"-->
<!--                          @click.stop="viewDetail(scope.row)"-->
<!--                          class="view-btn"-->
<!--                  >-->
<!--                    查看-->
<!--                  </el-button>-->
<!--                  <el-button-->
<!--                          type="text"-->
<!--                          size="small"-->
<!--                          icon="el-icon-edit"-->
<!--                          @click.stop="editShop(scope.row)"-->
<!--                          class="edit-btn"-->
<!--                  >-->
<!--                    编辑-->
<!--                  </el-button>-->
<!--                </div>-->
<!--              </template>-->
<!--            </el-table-column>-->
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-sizes="[10, 20, 30, 50]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  :pager-count="5"
          />
        </div>
      </div>

      <!-- 底部操作按钮 -->
      <div class="dialog-footer">
        <el-button
                size="medium"
                @click="close"
                class="cancel-btn"
        >
          <i class="el-icon-close"></i>
          取消
        </el-button>
<!--        <el-button-->
<!--                size="medium"-->
<!--                type="primary"-->
<!--                @click="ok"-->
<!--                :disabled="!curShop"-->
<!--                class="confirm-btn"-->
<!--        >-->
<!--          <i class="el-icon-check"></i>-->
<!--          确认选择 ({{ curShop ? curShop.name : '请先选择油站' }})-->
<!--        </el-button>-->
      </div>
    </el-dialog>

    <!-- 油站选择子组件 -->
    <eShop
            :formData="formData1"
            :visible.sync="visible1"
            :title="title1"
            :closeForm="closeForm1"
            v-on:eventChoose="eChooseShop"
    />
  </div>
</template>

<script>
  import eShop from "./eShopList";
  import moment from "moment";

  export default {
    components: {
      eShop
    },
    name: 'eBindOilShopList',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "油站选择与绑定",
      },
      closeForm: Function,
    },
    data() {
      return {
        formData1: {},
        visible1: false,
        title1: '',
        index: '',
        curShop: null,
        id: '',
        name: '',
        keywords: '',
        fileList: [],
        mList: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
        item: {},
        searchForm: {
          name: "",
          mobile: '',
          status: '',
          company_department_id: '',
          shop_id: null,
          shop_name: null,
          role_id: '',
          third_shop_id:'',
          subsidy_rate:0,
          foreign_shop_id:'',
          business_rate:0
        },
      };
    },
    mounted() {
      this.DataList();
    },
    methods: {
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      closeForm1() {
        // 子组件关闭逻辑
      },
      chooseShop() {
        this.title1 = "选择油站";
        this.formData1.cate_id=13;
        this.visible1 = true;
      },
      eChooseShop(id, ...params) {
        this.searchForm.shop_id = id;
        this.searchForm.shop_name = params[0];
        this.$message.success(`已选择油站: ${params[0]}`);
      },
      handleSizeChange(newSize) {
        this.pageSize = newSize;
        this.DataList();
      },
      handleCurrentChange(newPage) {
        this.pageNum = newPage;
        this.DataList();
      },
      onClose() {
        this.$emit('update:visible', false);
        this.closeForm && this.closeForm();
      },
      close() {
        this.$emit('update:visible', false);
        this.closeForm && this.closeForm();
      },
      ok() {
        if (!this.curShop) {
          this.$message.warning('请先选择油站');
          return;
        }
        this.$emit('eventChoose', this.id, this.name, this.item);
        this.$emit('update:visible', false);
        this.closeForm && this.closeForm();
        this.$message.success(`成功选择油站: ${this.name}`);
      },
      DataList() {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          third_shop_id: this.searchForm.third_shop_id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          keywords: this.keywords
        };

        this.$axios.findShopBindThirdListP(param).then(res => {
          if (res.code == 200) {
            this.mList = res.data.data || [];
            this.total = res.data.total || 0;
          } else {
            this.$message.error(res.message || '获取数据失败');
          }
        }).catch(error => {
          console.error(error);
          this.$message.error('网络请求失败');
        });
      },
      handleSelectionChange(row) {
        this.id = row.id;
        this.name = row.name;
        this.item = row;
        this.$message.info(`已选中: ${row.name}`);
      },
      handleRowClick(row) {
        this.curShop = row;
        this.handleSelectionChange(row);
      },
      handleQuery() {
        this.pageNum = 1;
        this.DataList();
      },
      handleReset() {
        this.keywords = '';
        this.pageNum = 1;
        this.DataList();
        this.$message.info('已重置查询条件');
      },
      handleBind() {
        if (!this.searchForm.shop_id) {
          this.$message.warning('请先选择油站');
          return;
        }
        if (!this.searchForm.foreign_shop_id) {
          this.$message.warning('请输入太米门店ID');
          return;
        }
        if (!this.searchForm.subsidy_rate) {
          this.$message.warning('请输入补贴比例');
          return;
        }

        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          shop_id: this.searchForm.shop_id,
          third_shop_id:this.searchForm.third_shop_id,
          subsidy_rate:this.searchForm.subsidy_rate,
          business_rate:this.searchForm.business_rate,
          foreign_shop_id:this.searchForm.foreign_shop_id,
        };
        this.$axios.shopBindThirdSave(param).then(res => {
          if (res.code == 200) {
            this.$message.success(`油站绑定成功: ${this.searchForm.shop_name}`);
          } else {
            this.$message.error(res.msg || '绑定失败');
          }
        }).catch(error => {
          console.error(error);
          this.$message.error('网络请求失败');
        });

      },
      getCategoryType(categoryName) {
        const types = {
          '加油站': 'success',
          '加气站': 'warning',
          '充电站': 'info',
          '综合站': 'danger',
          '油站': 'primary'
        };
        return types[categoryName] || 'info';
      },
      tableRowClassName({ rowIndex }) {
        if (this.curShop && this.mList[rowIndex] && this.mList[rowIndex].id === this.curShop.id) {
          return 'selected-row';
        }
        return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
      },
      viewDetail(row) {
        this.$message.info(`查看油站详情：${row.name}`);
        // 这里可以打开详情弹窗或跳转到详情页
      },
      editShop(row) {
        this.$message.info(`编辑油站：${row.name}`);
        // 这里可以打开编辑弹窗
      }
    },
    watch: {
      visible(val) {
        if (val) {
          console.log(this.formData)
          this.searchForm.third_shop_id=this.formData.id;
          this.handleReset();
          this.DataList();
        } else {
          this.curShop = null;
          this.searchForm.shop_id = null;
          this.searchForm.shop_name = null;
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .bind-oilshop-dialog {
    /deep/ .el-dialog {
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);
    }

    /deep/ .el-dialog__header {
      background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
      padding: 18px 24px;

      .el-dialog__title {
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 1px;
      }

      .el-dialog__headerbtn {
        top: 20px;

        .el-dialog__close {
          color: #fff;
          font-size: 20px;

          &:hover {
            color: #ffd04b;
          }
        }
      }
    }

    /deep/ .el-dialog__body {
      padding: 0;
      background-color: #f9f9f9;
    }
  }

  // 公共样式
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: linear-gradient(to right, #f8f9fa, #ffffff);
    border-bottom: 1px solid #e8e8e8;

    .header-left {
      display: flex;
      align-items: center;

      .section-icon {
        font-size: 18px;
        color: #4b6cb7;
        margin-right: 10px;
      }

      .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        letter-spacing: 1px;
      }
    }
  }

  // 查询区域
  .query-section {
    background: #fff;
    margin: 0;
    border-bottom: 1px solid #e8e8e8;

    .query-form {
      padding: 20px;

      /deep/ .el-form-item {
        margin-bottom: 0;
      }

      .query-btn {
        background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
        border: none;
        padding: 10px 24px;
        border-radius: 6px;
        font-weight: 500;

        &:hover {
          opacity: 0.9;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(75, 108, 183, 0.3);
        }
      }

      .reset-btn {
        padding: 10px 24px;
        border-radius: 6px;
        border: 1px solid #dcdfe6;

        &:hover {
          background-color: #f5f5f5;
          border-color: #c0c4cc;
        }
      }
    }
  }

  // 保存区域
  .save-section {
    background: #fff;
    margin: 0;
    border-bottom: 1px solid #e8e8e8;

    .selected-info {
      .el-tag {
        padding: 8px 16px;
        border-radius: 20px;
        font-weight: 500;

        i {
          margin-right: 5px;
        }
      }
    }

    .save-form {
      padding: 20px;

      /deep/ .el-form-item {
        margin-bottom: 0;
      }

      .shop-select-input {
        /deep/ .el-input__inner {
          background-color: #f9f9f9;
          cursor: pointer;

          &:hover {
            border-color: #4b6cb7;
          }
        }
      }

      .select-btn {
        background-color: #4b6cb7;
        color: #fff;
        border: none;
        border-radius: 0 4px 4px 0;

        &:hover {
          background-color: #3a5999;
        }
      }

      .bind-btn {
        background: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
        border: none;
        padding: 10px 28px;
        border-radius: 6px;
        font-weight: 500;

        &:hover:not(.is-disabled) {
          opacity: 0.9;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 176, 155, 0.3);
        }

        &.is-disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }
    }
  }

  // 表格区域
  .table-section {
    background: #fff;
    margin: 0;

    .table-info {
      .total-info {
        font-size: 14px;
        color: #666;
        background: #f0f2f5;
        padding: 6px 16px;
        border-radius: 20px;

        i {
          margin-right: 6px;
          color: #4b6cb7;
        }
      }
    }

    .table-wrapper {
      padding: 0 20px;

      /deep/ .el-table {
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        overflow: hidden;

        // 表格背景色
        &,
        .el-table__body-wrapper,
        .el-table__fixed,
        .el-table__fixed-right {
          background-color: #f5f5f5 !important;
        }

        // 表头背景色
        .el-table__header-wrapper {
          background-color: #f5f5f5 !important;
        }

        // 行背景色
        .el-table__row {
          background-color: #f5f5f5 !important;

          &.selected-row {
            background-color: #e8f4ff !important;

            td {
              background-color: #e8f4ff !important;
            }
          }

          &.even-row {
            td {
              background-color: #f5f5f5 !important;
            }
          }

          &.odd-row {
            td {
              background-color: #ffffff !important;
            }
          }

          &:hover {
            td {
              background-color: #edf7ff !important;
            }
          }
        }

        // 单元格内容样式
        .cell-content {
          display: flex;
          align-items: center;

          .cell-icon {
            margin-right: 8px;
            color: #4b6cb7;
            font-size: 14px;
          }

          .code-text {
            font-family: 'Courier New', monospace;
            font-weight: bold;
            color: #333;
            letter-spacing: 0.5px;
          }

          .name-text {
            font-weight: 600;
            color: #333;
          }

          .address-text {
            color: #666;
            line-height: 1.4;
          }

          .mobile-text {
            color: #333;
            font-weight: 500;
          }

          .empty-text {
            color: #999;
            font-style: italic;
          }
        }

        // 选择单选框
        .selection-radio {
          /deep/ .el-radio__inner {
            width: 18px;
            height: 18px;
            border-color: #4b6cb7;

            &::after {
              width: 8px;
              height: 8px;
              background-color: #4b6cb7;
            }
          }

          /deep/ .el-radio__input.is-checked .el-radio__inner {
            border-color: #4b6cb7;
            background: #fff;
          }
        }

        // 操作按钮
        .action-buttons {
          display: flex;
          justify-content: center;
          gap: 8px;

          .view-btn {
            color: #4b6cb7;
            font-weight: 500;

            &:hover {
              color: #3a5999;
              transform: translateY(-1px);
            }
          }

          .edit-btn {
            color: #00b09b;
            font-weight: 500;

            &:hover {
              color: #009688;
              transform: translateY(-1px);
            }
          }
        }
      }
    }

    // 分页
    .pagination-wrapper {
      padding: 20px;
      background-color: #fff;
      border-top: 1px solid #e8e8e8;

      /deep/ .el-pagination {
        display: flex;
        justify-content: flex-end;

        .el-pagination__total,
        .el-pagination__sizes,
        .el-pagination__jump {
          font-weight: 500;
        }

        .el-pager {
          .number {
            font-weight: 500;

            &.active {
              background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
              border-color: #4b6cb7;
            }

            &:hover {
              color: #4b6cb7;
            }
          }
        }

        .btn-prev,
        .btn-next {
          &:hover {
            color: #4b6cb7;
          }
        }
      }
    }
  }

  // 底部操作按钮
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding: 24px;
    background: linear-gradient(to right, #f8f9fa, #ffffff);
    border-top: 1px solid #e8e8e8;

    .cancel-btn {
      padding: 12px 32px;
      border-radius: 8px;
      font-weight: 500;
      border: 1px solid #dcdfe6;

      &:hover {
        background-color: #f5f5f5;
        border-color: #c0c4cc;
        transform: translateY(-1px);
      }
    }

    .confirm-btn {
      padding: 12px 40px;
      border-radius: 8px;
      font-weight: 500;
      background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
      border: none;
      letter-spacing: 1px;

      &:hover:not(.is-disabled) {
        opacity: 0.95;
        transform: translateY(-1px);
        box-shadow: 0 6px 20px rgba(75, 108, 183, 0.3);
      }

      &.is-disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none !important;
      }
    }
  }

  // 动画效果
  /deep/ .el-dialog {
    animation: dialogSlideIn 0.3s ease-out;
  }

  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  // 响应式设计
  @media (max-width: 992px) {
    .bind-oilshop-dialog {
      /deep/ .el-dialog {
        width: 90% !important;
        margin-top: 5vh !important;
      }
    }

    .section-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    .query-form,
    .save-form {
      /deep/ .el-form {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      /deep/ .el-form-item {
        width: 100%;

        .el-input {
          width: 100% !important;
        }
      }
    }

    .dialog-footer {
      flex-direction: column;

      .el-button {
        width: 100%;
      }
    }
  }
</style>
